import React, { useMemo } from 'react';
import { BwjNav } from '../../../../framework/components/bwj-nav';
import { IProjectOverviewModel } from '../../../../entities-generated/models/project/project-overview-model';
import { INavLink, INavLinkGroup } from '@fluentui/react';
import { AppRoutes, toProjectSlug } from '../../../app-routes';
import { forEach } from '../../../../framework/utils/collection';
import { toKebabCase } from '../../../../framework/utils/string';

interface IProjectOverviewSideNavProps {
  activeKey: string;
  projectId: string;
  site: string | undefined;
  project: IProjectOverviewModel;
}

const getNavLinkGroups = (projectId: string, project: IProjectOverviewModel) => {
  const links: INavLink[] = [{
    name: AppRoutes.projectOverviewAbout.sideMenuLabel ?? '[err]',
    url: AppRoutes.projectOverviewAbout.url(toProjectSlug(projectId)),
    icon: AppRoutes.projectOverviewAbout.icon,
    key: AppRoutes.projectOverviewAbout.key,
  }];
  forEach(project.workAreas, site => {
    const slug = toKebabCase(site.name);
    links.push({
      name: site.name,
      url: AppRoutes.projectOverviewInstallSite.url(toProjectSlug(projectId), slug),
      icon: AppRoutes.projectOverviewInstallSite.icon,
      key: `${AppRoutes.projectOverviewInstallSite.key}-${slug}`,
    });
  });
  links.push({
    name: AppRoutes.projectOverviewMaterials.sideMenuLabel ?? '[err]',
    url: AppRoutes.projectOverviewMaterials.url(toProjectSlug(projectId)),
    icon: AppRoutes.projectOverviewMaterials.icon,
    key: AppRoutes.projectOverviewMaterials.key,
  });
  const navLinkGroups: INavLinkGroup[] = [
    {
      links,
    },
  ];
  return navLinkGroups;
};

export const ProjectOverviewSideNav: React.FunctionComponent<IProjectOverviewSideNavProps> = (props) => {
  const { activeKey, site } = props;
  const groups = getNavLinkGroups(props.projectId, props.project);
  const selectedKey = useMemo(() => {
    if (activeKey === AppRoutes.projectOverviewInstallSite.key
      || activeKey === AppRoutes.projectOverviewInstallSitePhotos.key
      || activeKey === AppRoutes.projectOverviewInstallSiteDoor.key) {
      return `${AppRoutes.projectOverviewInstallSite.key}-${site}`;
    }
    return activeKey;
  }, [activeKey, site]);

  return (
    <BwjNav
      groups={groups}
      selectedKey={selectedKey}
    />
  )
};
